module.exports = __webpack_public_path__ + "static/media/playStoreIcon.ec9d8824.svg";